# Ad Performance

This use case covers measurement and reporting of conversion rates for job ads posted through the SEEK API.

## Before you begin

Your software must support [Job Posting] as a prerequisite.

Once you have completed your internal build and test phases,
[contact SEEK’s support team] to certify your integration and grant access to Ad Performance for production hirer accounts.
This is a separate pre-release step to ensure integration compatibility and quality.

[contact SEEK’s support team]: https://au.employer.seek.com/contactus

## Implementation steps

1. Send [application complete signals] if your software posts job ads that [link out] to an external apply form
1. Embed the [Ad Performance Panel] in your web-based software to show detailed performance data to your hirers

[Ad Performance Panel]: /use-cases/ad-performance/panel
[application complete signals]: /use-cases/ad-performance/application-complete-signal
[Job Posting]: /use-cases/job-posting
[link out]: /use-cases/job-posting/application-methods#linking-out-to-an-external-apply-form
